import Reflux from 'reflux'
import bankactions from '../actions/bankactions'

class BankStore extends Reflux.Store {

    constructor() {
        super();
        this.state = {
            bank: {
                hasUnporcessedInvoice: false,
                upload: {
                    date: null,
                    fields: [],
                    masterDataFile: '',
                    bankStatementFile: '',
                    buyerSupplierFile1: '',
                    buyerSupplierFile2: '',
                    buyerSupplierFile3: '',
                    buyerSupplierFile4: '',
                    buyerSupplierFile5: '',
                    buyerSupplierFile6: '',
                    buyerSupplierFile7: '',
                    buyerSupplierFile8: '',
                    buyerSupplierFile9: '',
                    buyerSupplierFile10: '',
                    vszcompanies: {},
                    partners: {},
                    unprocessed: {},
                    processed: {},
                    bankName: '',
                    company: {},
                }
            },
        };
        this.listenables = bankactions;
    }

    onSetFlag = (flag, key) => {
        let data = this.state[key];
        data.hasUnporcessedInvoice = flag;
        this.setState({[key]: data}); // todo: check
    };

    onSetData = (data) => {
        let bank = this.state.bank;
        bank.upload.fields = data.fields;
        bank.upload.date = data.date;
        bank.upload.bankStatementFile = data.bankStatementFile;
        bank.upload.buyerSupplierFile1 = data.buyerSupplierFile1;
        bank.upload.buyerSupplierFile2 = data.buyerSupplierFile2;
        bank.upload.buyerSupplierFile3 = data.buyerSupplierFile3;
        bank.upload.buyerSupplierFile4 = data.buyerSupplierFile4;
        bank.upload.buyerSupplierFile5 = data.buyerSupplierFile5;
        bank.upload.buyerSupplierFile6 = data.buyerSupplierFile6;
        bank.upload.buyerSupplierFile7 = data.buyerSupplierFile7;
        bank.upload.buyerSupplierFile8 = data.buyerSupplierFile8;
        bank.upload.buyerSupplierFile9 = data.buyerSupplierFile9;
        bank.upload.buyerSupplierFile10 = data.buyerSupplierFile10;
        bank.upload.unprocessed = data.unprocessed;
        bank.upload.processed = data.processed;
        bank.upload.vszcompanies = data.vszcompanies;
        bank.upload.partners = data.partners;
        bank.upload.bankName = data.bankName;
        bank.upload.company = data.company;
        this.setState({bank: bank});
    };

    onSetProcessed = (data) => {
        let bank = this.state.bank;
        bank.upload.processed = data;
        this.setState({bank: bank});
    };

    onSetUnprocessed = (data) => {
        let bank = this.state.bank;
        bank.upload.unprocessed = data;
        this.setState({bank: bank});
    };
}

export default BankStore;


// WEBPACK FOOTER //
// ./src/store/bankstore.js